import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import * as myGlobals from 'src/app/globals';
import { HttpBulkResponseModel, HttpPaginationModel, HttpResponseModel } from 'src/app/models/response.model';
import { TrashModel } from 'src/app/models/trash.model';
@Injectable({
  providedIn: 'root',
})
export class TrashService {
  constructor(private http: HttpClient) {}
  restoreSubcription: Subject<boolean> = new Subject<boolean>();

  getTrashedItems(folderParams?: HttpPaginationModel, encrypted?: boolean): Observable<HttpResponseModel<TrashModel[]>> {
    let params: HttpParams = new HttpParams();
    if (folderParams) {
      if (encrypted) {
        params = new HttpParams()
          .set('size', folderParams.pageSize)
          .set('page', folderParams.pageNumber | 0)
          .set('encryptedStorageActive', encrypted);
      } else {
        params = new HttpParams().set('size', folderParams.pageSize).set('page', folderParams.pageNumber | 0);
      }
      if (folderParams.sortField && folderParams.sortDirection) {
        params = params.set('sortField', folderParams.sortField).set('sortDirection', folderParams.sortDirection);
      }
      if (folderParams.objectId) {
        params = params.set('objectId', folderParams.objectId);
      }
    }

    return this.http.get<HttpResponseModel<TrashModel[]>>(`${myGlobals.Config.API}/objects/trash/list-view`, { params });
  }

  trashItems(ids: string[]): Observable<HttpBulkResponseModel> {
    return this.http.post<HttpBulkResponseModel>(`${myGlobals.Config.API}/objects/bulk/trash`, { ids });
  }

  emptyTrash(): Observable<void> {
    return this.http.delete<void>(`${myGlobals.Config.API}/objects/empty-trash`);
  }

  deleteItems(ids: string[]): Observable<HttpBulkResponseModel> {
    return this.http.post<HttpBulkResponseModel>(`${myGlobals.Config.API}/objects/bulk/delete`, { ids });
  }

  restoreItems(ids: string[], parentId?: string): Observable<void> {
    const url = !parentId ? `${myGlobals.Config.API}/objects/bulk/restore` : `${myGlobals.Config.API}/objects/bulk/restore?parentId=${parentId}`;

    return this.http.put<void>(url, { ids });
  }
}
